import {GetterTree} from "vuex";
import {IState} from "@/apps/StudyInspiratorWidget/models/store-state-model";
import {IDictionary} from "@/shared/models/interface/dictionary-model";
import {ExplanationViewModel, ResultViewModel, StartViewModel} from "@/apps/StudyInspiratorWidget/models/view-models";
import {IQuestion} from "@/apps/StudyInspiratorWidget/models/question";

export default <GetterTree<IState, IState>>{
    labels(state): IDictionary<string> {
        return state.config.labels;
    },

    startViewModel(state): StartViewModel {
        return state.config.model as StartViewModel;
    },

    explanationViewModel(state): ExplanationViewModel {
        return state.config.model as ExplanationViewModel;
    },

    resultViewModel(state): ResultViewModel {
        return state.config.model as ResultViewModel;
    },

    // Question getters
    currentQuestion(state): IQuestion {
        return state.questions[state.currentIndex];
    },

    currentAnswer(state, getter): boolean {
        let currentId: string = getter.currentQuestion.id;
        return state.answers[currentId];
    },

    answers(state): IDictionary<boolean> {
        return state.answers;
    },

    chosenAnswers(state, getter): string[] {
        return Object.keys(getter.answers).filter(key => getter.answers[key] == true);
    },

    numberOfQuestions(state): number {
        return state.questions.length;
    },

    isFinished(state): boolean {
        return state.currentIndex >= state.questions.length;
    },

    canMoveBackwards(state): boolean {
        return state.currentIndex !== 0;
    },

    canMoveForwards(state): boolean {
        return state.answers && state.currentIndex < Object.keys(state.answers).length;
    },

    progress(state): number {
        return state.currentIndex / state.questions.length * 100;
    },

    showResults(state): boolean {
        let numberOfTrueAnswers: number = Object.values(state.answers).filter(x => x == true).length;
        return numberOfTrueAnswers > 0;
    },

    highestRating(state): number {
        if (state.results) {
            let ratings: number[] = Object.keys(state.results).map(x => parseInt(x));
            return ratings ? Math.max(...ratings) : 0;
        }

        return 0;
    },

    sortedRatings(state): string[] {
        let results = state.results;
        if (results) {
            return Object.keys(results).sort().reverse();
        }

        return [];
    },

    progressLabel(state, getter): string {
        let label = getter.labels.progress;

        if (label) {
            label = label.replace("{0}", state.currentIndex + 1);
            label = label.replace("{1}", getter.numberOfQuestions);
        }

        return label;
    }
}
